// extracted by mini-css-extract-plugin
export default {"AppArticleTitle":"AppArticleTitle_AppArticleTitle__kg73q"};